import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  CategoriesAndTypesDto,
  CategoriesAndTypesRequestDto,
  NewsCategoryCountResponseDto,
  NewsDto,
  ResponseDto,
} from '../../dto';
import { BaseApiService } from './base-api.service';

@Injectable({
    providedIn: 'root'
})
export class NewsApiService {
    private readonly url: string = 'service/contactcloud/news';

    constructor(private readonly baseApiService: BaseApiService) {
    }

    getCategoriesAndTypes(): Observable <CategoriesAndTypesDto[]> {
        return this.baseApiService.get<CategoriesAndTypesDto[]>(`${this.url}/categoriesAndTypes`, { showError: true });
    }

    getCategoryCountByCompanyId(companyId: number): Observable <NewsCategoryCountResponseDto> {
        return this.baseApiService.get<NewsCategoryCountResponseDto>(`${this.url}/category/count`, {
          params: {companyId}, showError: true
        });
    }

    getNews(params: CategoriesAndTypesRequestDto): Observable<ResponseDto<NewsDto>> {
        return this.baseApiService.get<ResponseDto<NewsDto>>(`${this.url}/content`, {
            // @ts-ignore
            params: {
                ...params,
                ...(params.typeIds?.length ? { typeIds: params.typeIds.join(',') } : {})
            },
            showError: true,
        })
        .pipe(catchError(() => {
            return of({
                page: 1,
                pageSize: 0,
                resultCount: 0,
                totalCount: 0,
                content: [],
            });
        }));
    }
}
